var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    fill: "var(--accent-color)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.52-279.52h88.96V-528h-88.96v248.48Zm44.27-309.18q20.01 0 33.76-13.53 13.75-13.54 13.75-33.56 0-20.01-13.53-33.76-13.54-13.75-33.56-13.75-20.01 0-33.76 13.53-13.75 13.54-13.75 33.56 0 20.01 13.53 33.76 13.54 13.75 33.56 13.75Zm.49 511.92q-83.8 0-157.19-31.46-73.38-31.46-128.38-86.47-55.01-55-86.47-128.34T76.78-480.46q0-84.06 31.46-156.95 31.46-72.88 86.47-127.88 55-55.01 128.34-86.47t157.41-31.46q84.06 0 156.95 31.46 72.88 31.46 127.88 86.47 55.01 55 86.47 128.11 31.46 73.11 31.46 156.9 0 83.8-31.46 157.19-31.46 73.38-86.47 128.38-55 55.01-128.11 86.47-73.11 31.46-156.9 31.46Zm-.28-98q127.74 0 216.48-88.74T785.22-480q0-127.74-88.74-216.48T480-785.22q-127.74 0-216.48 88.74T174.78-480q0 127.74 88.74 216.48T480-174.78ZM480-480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.67ba6eef7a820212fdd3ea90c7ae6554.svg";
export { ForwardRef as ReactComponent };